import { createFileRoute } from "@tanstack/react-router";
import { VerifyEmailPage } from "@/modules/auth/presentation/pages/VerifyEmailPage";

export const Route = createFileRoute("/verify-email")({
  component: VerifyEmailPage,
});
